/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TimeSeriesPoint {
    getFixupPrototypeFunction() { return TimeSeriesPoint.fixupPrototype; }

    static newInstance(model: Partial<TimeSeriesPoint>): TimeSeriesPoint {
        let obj = Object.assign(new TimeSeriesPoint(), model);
        TimeSeriesPoint.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TimeSeriesPoint>): TimeSeriesPoint {
        if (!model) return null;
        return TimeSeriesPoint.newInstance(<TimeSeriesPoint> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TimeSeriesPoint) {
        if (!obj) return;

        models.TimeSeriesPoint.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TimeSeriesPoint): boolean {
        Object.setPrototypeOf(obj, TimeSeriesPoint.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.average === undefined) {
            this.average = 0;
        }
        if (this.total === undefined) {
            this.total = 0;
        }
        if (this.minimum === undefined) {
            this.minimum = 0;
        }
        if (this.maximum === undefined) {
            this.maximum = 0;
        }
        if (this.count === undefined) {
            this.count = 0;
        }
        if (typeof this.timestamp === "string") {
            this.timestamp = new Date(<string><any>this.timestamp);
        }
    }

    /**
     * Timestamp in ISO format
     */
    timestamp: Date;

    /**
     * Average value
     */
    average: number;

    /**
     * Total value
     */
    total: number;

    /**
     * Minimum value
     */
    minimum: number;

    /**
     * Maximum value
     */
    maximum: number;

    /**
     * Count
     */
    count: number;

}
